const updates = [
  { date: '07-31', title: '红桃视频上线「暑期档」专题页，百部热剧一网打尽', tag: '红桃视频', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-30', title: '樱花视频更新《逆流时光》全30集，4K高清版本已同步', tag: '樱花视频', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-29', title: '糖豆视频短剧频道全新改版，竖屏沉浸式观影体验', tag: '糖豆视频', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-28', title: '芭乐视频新增「热门搜索」功能，实时追踪全网热度', tag: '平台动态', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '红桃视频海外剧场重磅回归，多部高分美剧独家上线', tag: '红桃视频', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '樱花视频纪录片频道开放，自然人文佳作免费观看', tag: '樱花视频', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '糖豆视频「怀旧经典」系列上线，珍藏老片修复版首发', tag: '糖豆视频', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-24', title: '芭乐视频接入第五个特色平台，内容库突破2000部', tag: '平台动态', tagColor: 'bg-primary-100 text-primary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[400px] lg:shrink-0">
            <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">最新动态</span>
            <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新动态
            </h2>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              实时追踪红桃视频、樱花视频、糖豆视频等特色平台的更新动态，不错过任何精彩内容。
            </p>
            <div className="mt-6 hidden lg:block">
              <div className="w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20newsroom%20atmosphere%20with%20warm%20coral%20and%20dark%20tones%2C%20abstract%20dynamic%20composition%20with%20floating%20light%20particles%2C%20modern%20media%20streaming%20aesthetic%2C%20film%20texture%2C%20energetic%20yet%20elegant%20mood&width=800&height=600&seq=updates-side-bale&orientation=landscape"
                  alt="最新动态"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="space-y-1">
              {updates.map((item, idx) => (
                <a
                  key={idx}
                  href="#cards"
                  className="flex items-start gap-4 p-4 rounded-xl hover:bg-background-200/60 transition-colors cursor-pointer group"
                >
                  <span className="text-xs font-mono text-foreground-400 whitespace-nowrap mt-0.5">
                    {item.date}
                  </span>
                  <span className={`shrink-0 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                  <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors leading-relaxed flex-1">
                    {item.title}
                  </span>
                  <span className="text-foreground-300 text-xs mt-0.5 opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}